import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  getCountryFOB,
  getShipmentFOB,
  getShipmentsTotalFob,
  getShipmentsUnits,
} from '@app/formulas.utils';
import { FollowTypes } from '@app/models/follow';
import { Roles } from '@app/models/user';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';

import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';
import * as FollowShipmentActions from '@core/actions/follow-shipment.actions';
import * as fromProductShipment from '@core/reducers/product-shipment.reducer';

import * as rolesUtils from '@app/role.utils';

import { ConfirmationModalComponent } from '@app/modules/shared/confirmation-modal/confirmation-modal.component';

const homeFobTypes = [
  { name: 'FOB ABIERTO', value: 'openFOB' },
  { name: 'FOB CERRADO', value: 'closedFOB' },
  { name: 'FOB CUSTOM', value: 'customFOB' },
];
const petsFobTypes = [{ name: 'FOB cerrado', value: 'closedFOB' }];

const clothingFobTypes = [
  { name: 'FOB inicial', value: 'initialFOB' },
  { name: 'FOB final', value: 'finalFOB' },
];

const altElectroFobTypes = [
  {
    name: 'FOB ABIERTO 220',
    value: 'openFOB220',
    CountryIds: [43, 173, 30], // Chile, Peru, Brasil
  },
  {
    name: 'FOB CERRADO 220',
    value: 'closedFOB220',
    CountryIds: [43, 173, 30], // Chile, Peru Brasil
  },
  {
    name: 'FOB ABIERTO 110',
    value: 'openFOB110',
    CountryIds: [30, 47], // Brasil, Colombia
  },
  {
    name: 'FOB CERRADO 110',
    value: 'closedFOB110',
    CountryIds: [30, 47], // Brasil, Colombia
  },
  {
    name: 'FOB ABIERTO 220 AR',
    value: 'openFOB220ARG',
    CountryIds: [10], // Argentina
  },
  {
    name: 'FOB CERRADO 220 AR',
    value: 'closedFOB220ARG',
    CountryIds: [10], // Argentina
  },
];

const electroFobTypes = [
  {
    name: 'FOB ABIERTO',
    value: 'openFob',
  },
  {
    name: 'FOB CERRADO',
    value: 'closedFob',
  },
];

const ALTELECTRO_DEFAULT_FOBS_CLOSED = {
  10: 'closedFOB220ARG',
  30: 'closedFOB110',
  43: 'closedFOB220',
  47: 'closedFOB110',
  173: 'closedFOB220',
};

const ALTELECTRO_DEFAULT_FOBS_OPEN = {
  10: 'openFOB220ARG',
  30: 'openFOB110',
  43: 'openFOB220',
  47: 'openFOB110',
  173: 'openFOB220',
};

@Component({
  selector: 'app-country-shipments2',
  templateUrl: './country-shipments2.component.html',
  styleUrls: ['./country-shipments2.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryShipments2Component implements OnInit {
  @Input()
  selectedProducts;

  @Input()
  productShipments = [];

  @Input()
  valuee: any;

  @Input()
  role;

  @Input()
  follow;

  @Input()
  product;

  @Input()
  followShipments;

  @Input()
  productCountry;

  @Input()
  countryUnitsPerBox;

  @Input()
  chain;

  @Input()
  pcsIdsWithUnits;

  @Input()
  boxValues;

  @Input()
  Country;

  @Input()
  allproformas;

  @Output()
  changeUnits;

  @Output()
  edit = new EventEmitter();

  productShipments$ = this.store.pipe(select(fromProductShipment.getAll));
  ProductShipmentIds = [];
  fobSelect = {};
  pcsRed;
  boxRed;
  fobTyp = [];
  _modalRef;
  typeFob = {
    openFOB220: 'FOB ABIERTO 220',
    closedFOB220: 'FOB CERRADO 220',
    openFOB110: 'FOB ABIERTO 110',
    closedFOB110: 'FOB CERRADO 110',
    openFOB220ARG: 'FOB ABIERTO 220 AR',
    closedFOB220ARG: 'FOB CERRADO 220 AR',
    closedFOB: 'FOB CERRADO',
    openFOB: 'FOB ABIERTO',
    initialFOB: 'FOB inicial',
    finalFOB: 'FOB final',
  };

  // shipments;

  get isArrivals() {
    return this.follow.arrivals ? 'Arribos' : 'Embarques';
  }

  get shipments() {
    if (this.product && this.product.CountryId) {
      if (this.follow.arrivals) {
        return this.followShipments.map((shipment, i) => {
          return {
            name: shipment.arrival,
            id: shipment.id,
            fuub: this.fobTyp,
            position: shipment.position,
            fob: shipment.fob,
            fobType: shipment.fobType,
            weightedFob: shipment.weightedFob,
            ProformaId: shipment.ProformaId,
          };
        });
      } else {
        return this.followShipments
          .filter((s) => s.CountryId === this.product.CountryId)
          .map((shipment, i) => {
            return {
              name: shipment.departureDate,
              id: shipment.id,
              fuub: this.fobTyp,
              position: shipment.position,
              fob: shipment.fob,
              fobType: shipment.fobType,
              weightedFob: shipment.weightedFob,
              ProformaId: shipment.ProformaId,
            };
          });
      }
    } else {
      return [];
    }
  }

  get filteredProductShipments() {
    if (this.productShipments) {
      if (this.follow.arrivals) {
        if (this.chain) {
          return this.productShipments.filter(
            (p) =>
              this.shipments.map((s) => s.id).includes(p.FollowArrivalsId) &&
              (p.ChainId === this.chain.id || null)
          );
        } else {
          const aux = this.productShipments.filter((p) =>
            this.shipments.map((s) => s.id).includes(p.FollowArrivalsId)
          );
          return aux;
        }
      } else {
        if (this.chain) {
          return this.productShipments.filter(
            (p) =>
              this.shipments.map((s) => s.id).includes(p.ShipmentId) &&
              (p.ChainId === this.chain.id || null)
          );
        } else {
          return this.productShipments.filter((p) =>
            this.shipments.map((s) => s.id).includes(p.ShipmentId)
          );
        }
      }
    } else {
      return [];
    }
  }

  get productShipmentsByFollowShipmentId() {
    if (this.filteredProductShipments) {
      return this.filteredProductShipments.reduce((acc, shipment) => {
        acc[
          this.follow.arrivals ? shipment.FollowArrivalsId : shipment.ShipmentId
        ] = shipment;

        const fob = getShipmentFOB(
          this.product,
          this.productCountry,
          shipment,
          this.follow.type,
          [
            {
              default: true,
              key: 'initialFOB',
              name: 'FOB Inicial',
            },
          ]
        );

        return acc;
      }, {});
    } else {
      return {};
    }
    // }
  }

  get unitsPerBox() {
    if (this.product && this.product.metadata && this.productCountry) {
      const countryName = this.Country
        ? this.Country.name
        : this.productCountry.Country.name;
      const countryId = this.Country
        ? this.Country.id
        : this.productCountry.Country.id;
      let fieldName = `boxUnits${countryName}`;
      if (countryId === 173) {
        fieldName = `boxUnitsPeru`;
      }
      return (
        this.product.metadata.master || this.product.metadata[fieldName] || 1
      );
    } else {
      return 1;
    }
  }

  get isCountryBuyer() {
    return rolesUtils.isCountryUser(this.role);
  }

  get isRegionalBuyer() {
    return this.role === Roles.RegionalBuyer;
  }

  get isPlanner() {
    return rolesUtils.isPlanner(this.role);
  }

  get isProductManager() {
    return rolesUtils.isProductManager(this.role);
  }

  get isRegionalManager() {
    return rolesUtils.isRegionalManager(this.role);
  }

  get isQC() {
    return rolesUtils.isSupervisorQC(this.role);
  }

  get currentChains() {
    const business =
      this.productCountry &&
      this.follow.Businesses &&
      this.follow.Businesses.find((b) => {
        return (
          b.CountryId === this.productCountry.CountryId &&
          b.code === this.productCountry.businessUnit
        );
      });

    return (business && business.Chains) || [];
  }

  get disabledFOB() {
    console.log('this.follow.status => ', this.follow.status);
    if (this.follow.status === 1) {
      return true;
    }
    return false;
  }

  get totalShipmentsUnits() {
    return getShipmentsUnits(this.filteredProductShipments);
  }

  get totalShipmentsBoxes() {
    return this.totalShipmentsUnits / this.unitsPerBox || 0;
  }

  get totalShipmentsFob() {
    if (
      this.product &&
      this.productCountry &&
      this.follow &&
      this.filteredProductShipments
    ) {
      return getShipmentsTotalFob(
        this.product,
        this.productCountry,
        this.follow.type,
        [],
        this.filteredProductShipments
      );
    } else {
      return 0;
    }
  }

  get weightedFOB() {
    return this.totalShipmentsFob / this.totalShipmentsUnits || 0;
  }

  get followStatus() {
    return this.follow.status;
  }

  get followStatusValid() {
    const status = this.follow.status;
    console.log('status => ', status);
    if (
      status === 2 ||
      status === 3 ||
      status === 5 ||
      status === 7 ||
      status === 8
    ) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    private store: Store<any>,
    private fb: FormBuilder,
    private modal: NgbModal
  ) {}

  ngOnInit() {
    if (this.productShipments && this.productShipments.length > 0) {
      this.ProductShipmentIds = this.productShipments.map((x) => x.id);
    }

    // this.shipments = this.followShipments
    // .filter(s => s.CountryId === this.product.CountryId)
    // .map((shipment, i) => {
    //   return {
    //     name: shipment.departureDate,
    //     id: shipment.id,
    //     fuub: this.fobTyp,
    //     position: shipment.position,
    //     fob: shipment.fob,
    //     fobType: shipment.fobType,
    //     weightedFob: shipment.weightedFob,
    //     ProformaId: shipment.ProformaId
    //   };
    // });
  }

  showFob(shipment) {
    try {
      const [actualShipment] = this.filteredProductShipments.filter(
        (x) => x.ShipmentId === shipment.id
      );

      if (this.fobSelect[shipment.id]) {
        return this.fobSelect[shipment.id];
      } else {
        if (
          actualShipment &&
          actualShipment.fobType &&
          this.follow.type !== 'ALTELECTRO'
        ) {
          return this.typeFob[actualShipment.fobType];
        } else if (this.productCountry && this.productCountry.fobType) {
          return this.typeFob[this.productCountry.fobType];
        }
      }

      return '';
    } catch (err) {
      // No console.log(productShipments.length);
    }
  }

  getUnits(id) {
    if (this.pcsIdsWithUnits) {
      this.pcsRed = this.pcsIdsWithUnits.reduce((acc, pcs) => {
        acc[pcs.ShipmentId] = pcs.changes.units;

        return acc;
      }, {});

      if (this.pcsRed[id] >= 0) {
        return this.pcsRed[id];
      } else {
        return -1;
      }
    }
  }

  getBoxs(id) {
    if (this.boxValues) {
      this.boxRed = this.boxValues.reduce((acc, pcs) => {
        acc[pcs.ShipmentId] = pcs.boxValue;

        return acc;
      }, {});

      if (this.boxRed[id] >= 0) {
        return this.boxRed[id];
      } else {
        return -1;
      }
    }
  }

  emit(e, ShipmentId) {
    let value;
    try {
      value = parseInt(e.target.value, 10);
    } catch (e) {
      console.error(e);
    }

    const isValid = value % this.unitsPerBox === 0;

    if (!isValid && value !== 0) {
      // Approximate units
      const factor = Math.ceil(value / this.unitsPerBox);
      value = this.unitsPerBox * factor;
    }

    if (
      this.isCountryBuyer ||
      this.isProductManager ||
      this.isRegionalManager
    ) {
      this.edit.emit({
        ShipmentId,
        units: value,
        currentTotalUnits: getShipmentsUnits(this.filteredProductShipments),
        shipments: this.productShipmentsByFollowShipmentId,
      });
    }
  }

  emitBoxChange(e, ShipmentId) {
    let value;
    try {
      value = parseInt(e.target.value, 10);
    } catch (e) {
      console.error(e);
    }
    if (
      this.isCountryBuyer ||
      this.isProductManager ||
      this.isRegionalManager
    ) {
      this.edit.emit({
        ShipmentId,
        units: value * this.unitsPerBox,
        boxValue: value,
        currentTotalUnits: getShipmentsUnits(this.filteredProductShipments),
        shipments: this.productShipmentsByFollowShipmentId,
      });
    }
  }

  emitFobValueChange(e, ShipmentId) {
    let value;
    let type;
    let name;
    try {
      this.fobOptions.map((x) => {
        if (parseFloat(e.target.value) > 0) {
          value = parseFloat(e.target.value);
          type = x.value;
          name = x.name;
        }
      });
    } catch (e) {
      console.error(e);
    }

    this.fobSelect[ShipmentId] = name;
    if (this.selectedProducts && this.selectedProducts.length > 1) {
      // do nothing
    } else {
      this.edit.emit({ ShipmentId, fob: value });
    }
  }

  emitFobChange(e, ShipmentId) {
    let value;
    let type;
    let name;
    try {
      this.fobOptions.map((x) => {
        if (x.name === e.target.value) {
          value = parseFloat(x.fob);
          type = x.value;
          name = x.name;
        }
      });
    } catch (e) {
      console.error(e);
    }

    this.fobSelect[ShipmentId] = name;

    this.edit.emit({ ShipmentId, fobType: type });
  }

  getProductShipmentByShipmentId(ShipmentId: number) {
    if (this.follow.arrivals) {
      return (
        this.productCountry &&
        this.productCountry.Shipments &&
        this.productCountry.Shipments.length &&
        this.productCountry.Shipments.find(
          (x) => x.FollowArrivalsId === ShipmentId
        )
      );
    }
    return (
      this.productCountry &&
      this.productCountry.Shipments &&
      this.productCountry.Shipments.length &&
      this.productCountry.Shipments.find((x) => x.ShipmentId === ShipmentId)
    );
  }

  shipmentFOB(shipment) {
    const productShipment = this.getProductShipmentByShipmentId(shipment.id);
    if (this.productShipments) {
      const [currentProductShipment] = this.productShipments.filter(
        (x) => x.ShipmentId === shipment.id
      );

      if (currentProductShipment && currentProductShipment.fob > 0) {
        return currentProductShipment.fob;
      } else if (currentProductShipment && currentProductShipment.fobType) {
        return this.product.metadata[currentProductShipment.fobType] || 0;
      }
    }

    if (!productShipment) {
      return getCountryFOB(
        this.product,
        this.productCountry,
        this.follow.type,
        []
      );
      // return 0;
    }
    return getShipmentFOB(
      this.product,
      this.productCountry,
      productShipment,
      this.follow.type,
      []
    );
  }

  productMaster() {
    if (this.follow && this.follow.type === 'VESTUARIO') {
      return (
        this.productCountry.metadata && this.productCountry.metadata.master
      );
    } else {
      return this.product.metadata && this.product.metadata.master;
    }
  }

  get fobOptions() {
    let types = [];

    switch (this.follow.type) {
      case FollowTypes.Clothing:
        types = clothingFobTypes;
        break;

      case FollowTypes.Food:
      case FollowTypes.Home:
        types = homeFobTypes;
        break;

      case FollowTypes.Electro:
        types = electroFobTypes;
        break;

      case FollowTypes.Pets:
        types = petsFobTypes;
        break;

      case FollowTypes.AltElectro:
        const currentCountryId = this.productCountry.CountryId;
        types = altElectroFobTypes.filter((x) =>
          x.CountryIds.includes(currentCountryId)
        );

        break;

      default:
        types = [];
        break;
    }

    types = types.map((item) => {
      return {
        ...item,
        fob: this.product.metadata[item.value]
          ? this.product.metadata[item.value]
          : item.value === 'customFOB'
          ? 0
          : null,
      };
    });

    return types;
  }

  validate(fobValue) {
    if (!fobValue || !(fobValue > 0)) {
      return true;
    }
  }

  test(e, i) {
    console.log('e', e);
  }

  typeFobSelected(shipmentId) {
    // const productShipment = this.shipments.find(item => item.id === shipmentId)
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);

    if (productShipment) {
      const currentProforma = this.allproformas.find((p) =>
        this.follow.arrivals
          ? p.id === productShipment.ProformaArrivalId
          : p.id === productShipment.ProformaId
      );

      if (currentProforma) {
        if (this.follow.type === 'ALTELECTRO') {
          let fobType =
            productShipment.fobType !== 'customFOB'
              ? productShipment.fobType
              : productShipment.ProductCountry &&
                productShipment.ProductCountry.fobType
              ? productShipment.ProductCountry.fobType
              : currentProforma.fobType;

          if (fobType === null) {
            const countryId = this.productCountry.CountryId;

            if (countryId === 30 || countryId === 47) {
              fobType = 'closedFOB110';
            } else if (countryId === 10) {
              fobType = 'closedFOB220ARG';
            } else if (countryId === 43 || countryId === 173) {
              fobType = 'closedFOB220';
            }
          }
          if (
            productShipment.fobType === 'customFOB' &&
            parseFloat(productShipment.fob) > 0
          ) {
            return productShipment.fob;
          } else {
            return this.product.metadata[fobType];
          }
        } else if (this.follow.type === 'VESTUARIO') {
          let fobTypeClothing = 0;
          if (productShipment.weightedFob && productShipment.weightedFob > 0) {
            fobTypeClothing = productShipment.weightedFob || 0;
          } else if (this.productCountry.metadata.fob) {
            fobTypeClothing = this.productCountry.metadata.fob || 0;
          } else {
            fobTypeClothing = this.product.metadata.finalFOB || 0;
          }
          return fobTypeClothing;
        } else {
          const fobType = productShipment.fobType
            ? productShipment.fobType
            : this.productCountry.fobType;

          if (currentProforma && currentProforma.fobType !== fobType) {
            return this.product.metadata[currentProforma.fobType];
          }
          if (productShipment.fob > 0) {
            return productShipment.fob;
          }
        }
      }
      return 0;
    }
  }

  proformaFobType(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    let currentProformaFobType = 'SIN FOB';
    if (this.follow.arrivals) {
      if (productShipment && productShipment.ProformaArrivalId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma && currentProforma.fobType) {
          currentProformaFobType = currentProforma.fobType.includes('open')
            ? 'LCL'
            : currentProforma.fobType.includes('close')
            ? 'FCL'
            : currentProforma.fobType.includes('custom')
            ? 'CUSTOM'
            : 'SIN FOB';
        }
      }
    } else {
      if (productShipment && productShipment.ProformaId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma && currentProforma.fobType) {
          currentProformaFobType = currentProforma.fobType.includes('open')
            ? 'LCL'
            : currentProforma.fobType.includes('close')
            ? 'FCL'
            : currentProforma.fobType.includes('custom')
            ? 'CUSTOM'
            : 'SIN FOB';
        }
      }
    }
    return currentProformaFobType;
  }

  proformaLongCode(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    if (this.follow.arrivals) {
      if (productShipment && productShipment.ProformaArrivalId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma) {
          return currentProforma.longCode
            ? currentProforma.longCode
            : 'SIN PROFORMA';
        }
      }
    } else {
      if (productShipment && productShipment.ProformaId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma) {
          return currentProforma.longCode
            ? currentProforma.longCode
            : 'SIN PROFORMA';
        }
      }
    }

    return 'SIN PROFORMA';
  }

  shipmentWeightedFOB(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    let currrentWeightedFOB = 0;
    if (productShipment) {
      currrentWeightedFOB =
        productShipment &&
        productShipment.weightedFob &&
        productShipment.weightedFob > 0
          ? productShipment.weightedFob
          : 0;
    }
    return currrentWeightedFOB;
  }

  totalProduct(shipmentId) {
    const units =
      this.getUnits(shipmentId) > 0
        ? this.getUnits(shipmentId)
        : this.productShipmentsByFollowShipmentId[shipmentId] &&
          this.productShipmentsByFollowShipmentId[shipmentId].units > 0
        ? this.productShipmentsByFollowShipmentId[shipmentId].units
        : 0;
    const fob = this.typeFobSelected(shipmentId) || 0;
    return units * parseFloat(fob) || 0;
  }

  totalProforma(shipmentId) {
    let total = 0;
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    if (this.follow.arrivals) {
      if (productShipment && productShipment.ProformaArrivalId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma) {
          total = currentProforma.FollowArrivalsUnits.reduce((sum, p) => {
            let proformaFobType = currentProforma.fobType;
            if (this.follow.type === 'ALTELECTRO') {
              proformaFobType = proformaFobType.includes('closed')
                ? ALTELECTRO_DEFAULT_FOBS_CLOSED[p.ProductCountry.CountryId]
                : ALTELECTRO_DEFAULT_FOBS_OPEN[p.ProductCountry.CountryId];
            } else if (this.follow.type === 'VESTUARIO') {
              let fobClothing;
              let currentFobClothing = 0;
              if (
                p.ProductCountry.Product.metadata[
                  'productTypeClothing'
                ].includes('SET')
              ) {
                if (p.ProductCountry.metadata.fob) {
                  fobClothing = p.ProductCountry.metadata.fob || 0;
                } else {
                  fobClothing = p.ProductCountry.Product.metadata.finalFOB || 0;
                }
                currentFobClothing = parseFloat(fobClothing) || 0;
              }
              const currentUnits = p.units || 0;
              return (sum += currentFobClothing * currentUnits);
            }
            const currentFob =
              parseFloat(p.ProductCountry.Product.metadata[proformaFobType]) ||
              0;
            const currentUnits = p.units || 0;
            return (sum += currentFob * currentUnits);
          }, 0);
        }
      }
    } else {
      if (productShipment && productShipment.ProformaId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma) {
          total = currentProforma.ProductCountryShipments.reduce((sum, p) => {
            let proformaFobType = currentProforma.fobType;
            if (this.follow.type === 'ALTELECTRO') {
              proformaFobType = proformaFobType.includes('closed')
                ? ALTELECTRO_DEFAULT_FOBS_CLOSED[p.ProductCountry.CountryId]
                : ALTELECTRO_DEFAULT_FOBS_OPEN[p.ProductCountry.CountryId];
            } else if (this.follow.type === 'VESTUARIO') {
              let fobClothing;
              let currentFobClothing = 0;
              if (
                p.ProductCountry.Product.metadata[
                  'productTypeClothing'
                ].includes('SET')
              ) {
                if (p.ProductCountry.metadata.fob) {
                  fobClothing = p.ProductCountry.metadata.fob || 0;
                } else {
                  fobClothing = p.ProductCountry.Product.metadata.finalFOB || 0;
                }
                currentFobClothing = parseFloat(fobClothing) || 0;
              }
              const currentUnits = p.units || 0;
              return (sum += currentFobClothing * currentUnits);
            }
            const currentFob =
              parseFloat(p.ProductCountry.Product.metadata[proformaFobType]) ||
              0;
            const currentUnits = p.units || 0;
            return (sum += currentFob * currentUnits);
          }, 0);
        }
      }
    }
    return total.toFixed(2);
  }

  totalExtraCosts(shipmentId) {
    const units =
      this.getUnits(shipmentId) > 0
        ? this.getUnits(shipmentId)
        : this.productShipmentsByFollowShipmentId[shipmentId] &&
          this.productShipmentsByFollowShipmentId[shipmentId].units > 0
        ? this.productShipmentsByFollowShipmentId[shipmentId].units
        : 0;
    const currentWeightedFOB = this.shipmentWeightedFOB(shipmentId) || 0;
    return units * currentWeightedFOB || 0;
  }

  totals(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    if (this.follow.arrivals) {
      if (productShipment && productShipment.ProformaArrivalId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma) {
          return currentProforma.totalFob > 0 ? currentProforma.totalFob : 0;
        }
      }
    } else {
      if (productShipment && productShipment.ProformaId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma) {
          return currentProforma.totalFob > 0 ? currentProforma.totalFob : 0;
        }
      }
    }
    return 0;
  }

  proformaCountryId() {
    return this.Country ? this.Country.id : this.productCountry.Country.id;
  }

  proformaId(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    let currentProformaId = null;
    if (this.follow.arrivals) {
      if (productShipment && productShipment.ProformaArrivalId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma) {
          currentProformaId = currentProforma.id;
        }
      }
    } else {
      if (productShipment && productShipment.ProformaId) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma) {
          currentProformaId = currentProforma.id;
        }
      }
    }
    return currentProformaId;
  }

  proformaDetail(shipmentId) {
    return `/follows/${this.follow.id}/proformas/${this.proformaId(
      shipmentId
    )}`;
  }

  changeTypeProforma(shipmentId, e) {
    this._modalRef = this.modal.open(ConfirmationModalComponent);
    this._modalRef.componentInstance.title = 'Cambiar tipo de FOB';
    this._modalRef.componentInstance.continueButtonStyle = 'danger';
    this._modalRef.componentInstance.message =
      'Esta acción eliminará extra costos/descuento. ¿Estás seguro?';
    this._modalRef.result.then(
      (result) => {
        // do nothing
      },
      (confirmed) => {
        if (confirmed) {
          const productShipment =
            this.getProductShipmentByShipmentId(shipmentId);
          if (this.follow.arrivals) {
            if (productShipment && productShipment.ProformaArrivalId) {
              const currentProforma = this.allproformas.find(
                (p) => p.id === productShipment.ProformaArrivalId
              );
              if (currentProforma) {
                let newFobType =
                  e.target.value === 'LCL'
                    ? 'openFOB'
                    : e.target.value === 'FCL'
                    ? 'closedFOB'
                    : 'customFOB';
                let newFobTypeElectro;
                if (this.follow.type === 'ALTELECTRO') {
                  newFobTypeElectro = newFobType.includes('closed')
                    ? ALTELECTRO_DEFAULT_FOBS_CLOSED[
                        this.productCountry.CountryId
                      ]
                    : ALTELECTRO_DEFAULT_FOBS_OPEN[
                        this.productCountry.CountryId
                      ];
                }
                this.store.dispatch(
                  new ProformaActionTypes.ShipmentUpdateCancel(
                    currentProforma.id,
                    {
                      amountType: null,
                      amount: 0,
                      FollowId: currentProforma.FollowId,
                      proformaId: currentProforma.id,
                    }
                  )
                );
                this.store.dispatch(
                  new ProformaActionTypes.UpdateShipment(currentProforma.id, {
                    fobType: newFobType,
                    CountryId: currentProforma.CountryId,
                    FollowId: currentProforma.FollowId,
                  })
                );
                this.updateShipment(
                  currentProforma.FollowArrivalsId,
                  'fob',
                  newFobTypeElectro
                );
                this.recalculate(currentProforma.FollowArrivalsId);
              }
            }
          } else {
            if (productShipment && productShipment.ProformaId) {
              const currentProforma = this.allproformas.find(
                (p) => p.id === productShipment.ProformaId
              );
              if (currentProforma) {
                let newFobType =
                  e.target.value === 'LCL'
                    ? 'openFOB'
                    : e.target.value === 'FCL'
                    ? 'closedFOB'
                    : 'customFOB';
                let newFobTypeElectro;
                if (this.follow.type === 'ALTELECTRO') {
                  newFobTypeElectro = newFobType.includes('closed')
                    ? ALTELECTRO_DEFAULT_FOBS_CLOSED[
                        this.productCountry.CountryId
                      ]
                    : ALTELECTRO_DEFAULT_FOBS_OPEN[
                        this.productCountry.CountryId
                      ];
                }
                this.store.dispatch(
                  new ProformaActionTypes.ShipmentUpdateCancel(
                    currentProforma.id,
                    {
                      amountType: null,
                      amount: 0,
                      FollowId: currentProforma.FollowId,
                      proformaId: currentProforma.id,
                    }
                  )
                );
                this.store.dispatch(
                  new ProformaActionTypes.UpdateShipment(currentProforma.id, {
                    fobType: newFobType,
                    CountryId: currentProforma.CountryId,
                    FollowId: currentProforma.FollowId,
                  })
                );
                this.updateShipment(
                  currentProforma.ShipmentId,
                  'fob',
                  newFobTypeElectro
                );
                this.recalculate(currentProforma.ShipmentId);
              }
            }
          }
        }
      }
    );
  }

  updateShipment(shipmentId, typeUpdate, newFobType) {
    if (typeUpdate === 'fob') {
      let productShipment = this.getProductShipmentByShipmentId(shipmentId);
      productShipment['fobType'] = newFobType;
      let currentProforma = this.allproformas.find(
        (item) => item.id === productShipment.ProformaId
      );
      currentProforma['fobType'] = newFobType;
      this.allproformas = this.allproformas.filter(
        (item) => item.id !== currentProforma.id
      );
      this.allproformas.push(currentProforma);
      console.log('newFobTypeElectro => ', newFobType);

      // this.shipments = this.shipments.filter(item => item.id !== productShipment.id)
      this.shipments.push(productShipment);
    }
  }

  recalculate(shipmentId) {
    const productShipment = this.getProductShipmentByShipmentId(shipmentId);
    if (productShipment) {
      if (this.follow.arrivals) {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaArrivalId
        );
        if (currentProforma) {
          this.store.dispatch(
            new FollowShipmentActions.Load(currentProforma.FollowId)
          );
          this.store.dispatch(
            new ProformaActionTypes.Load(currentProforma.FollowId)
          );
        }
      } else {
        const currentProforma = this.allproformas.find(
          (p) => p.id === productShipment.ProformaId
        );
        if (currentProforma) {
          this.store.dispatch(
            new FollowShipmentActions.Load(currentProforma.FollowId)
          );
          this.store.dispatch(
            new ProformaActionTypes.Load(currentProforma.FollowId)
          );
        }
      }
    }
  }
}
